import React, { useState } from 'react';

import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import styles from '../../App.module.css';




const TestBcrypt = () => {

    const [ pw, setPW ] = useState('');
    const [ sub, setSub ] = useState(false);
    const [ salt, setSalt ] = useState('');
    const [ hash, setHash ] = useState('');
    const [ hashed, setHashed ] = useState('');
    

    const printPws = async (e) => {
        e.preventDefault();
        setSub(!sub);

        if ( sub ) {

        }
    };

  return (
    <Card body className={styles['Card']}>
        {!sub ? (
        <Form onSubmit={printPws}>
            <Form.Group as={Card} body className={styles['CardLvl2']}>
                <Form.Label as={Card.Title}>
                    Password
                </Form.Label>
                <Form.Control
                    required
                    type="text"
                    value={pw}
                    onChange={e => setPW( e.target.value )}
                />
                </Form.Group>

            <Button type="submit">Encrypt</Button>
        </Form>
        ) : (
            <div>
                <p>TestBcrypt</p>
                <p>Plain PW: {pw}</p>
                <p>Salt: {salt}</p>
                <p>Hash: {hash}</p>
                <p>Hashed PW: {hashed}</p>
                <Button onClick={printPws}>Go back</Button>
            </div>
        )}
    </Card>
  );
};

export default TestBcrypt;